import { useState, useEffect, useContext, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import config from "../../../../config/config";
import { useParams } from "react-router-dom";
import { toastError } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  ERROR_EXISTS,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import { AppContext } from "../../../../context/AppContext";
import { Modal, Button } from "react-bootstrap";

const ItemAttributeTableRows = ({
  rowsData,
  deleteTableRows,
  globalAttribute,
  attributeName,
  attributeValue,
  callback,
  itemNameForVariation,
}) => {
  const token = localStorage.getItem("Token");
  const [pull, setPull] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAttributePopup, setShowAttributePopup] = useState(false);
  const [modeltype, setModeltype] = useState("");
  const [deleteRowIndex, setDeleteRowIndex] = useState(null); // Track the row index to be deleted
  const [selectedRowAttributeId, setSelectedRowAttributeId] = useState(null); // Track the row index to be deleted
  const [selectedRowDate, setSelectedRowDate] = useState(null); // Track the row index to be deleted
  const loginUserId = localStorage.getItem("ID");
  const paramObject = useParams();
  const selectRef = useRef();

  // for App Context-
  const { autoGenerationFunction } = useContext(AppContext);

  // setting props into state-
  const [data, setData] = useState({
    newRowsData: rowsData,
    newGlobalAttribute: globalAttribute,
    newAttributeName: attributeName,
    newAttributeValue: attributeValue,
  });

  // Use Effect-
  useEffect(() => {
    setData({
      ...data,
      newRowsData: rowsData,
      newGlobalAttribute: globalAttribute,
      newAttributeName: attributeName,
      newAttributeValue: attributeValue,
    });
  }, [rowsData, pull]);

  // Insert Function-
  const insertAttributeFunction = (selected, Attributeid) => {
    const keyValues = selected.map((obj) => obj.value);
    const commaSeparatedValues = keyValues.join(",");

    if (selected) {
      // payload-
      const payload = {
        itemid: paramObject.id,
        attributeid: Attributeid || "",
        attributevalueid: commaSeparatedValues,
        loginUserId,
        ItemName: itemNameForVariation, // item name pass
      };

      // post-
      axios
        .post(`${config.itemsBaseUrl}/items/itemattributeinsert`, payload, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            autoGenerationFunction(res.data.ResponseCode);
            let filtervalue = data?.newAttributeValue.filter(
              (e) => e.Attributeid != Attributeid
            );
            // callback()
            setData({
              ...data,
              newAttributeValue: filtervalue,
            });
            setData({
              ...data,
              newAttributeValue: [...filtervalue, ...res.data.ResponseData],
            });
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
          } else {
            toastError(ERROR_MESSAGE);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  // Handle Attribute Change-
  const handleChangeAttributeValue = (
    selected,
    Attributeid,
    index,
    ID,
    prevLength
  ) => {


    console.log(prevLength, "value call by Ai")
    if (prevLength > selected?.length) {
      console.log("if call by Ai")
      setModeltype("Attributevalue");
      setDeleteRowIndex(index);
      setSelectedRowDate(selected);
      setSelectedRowAttributeId(Attributeid);
      setShowAttributePopup(true);
    } else {
      console.log("else call by Ai")
      insertAttributeFunction(selected, Attributeid);

      if (selected.length === 0) {
        deleteTableRows(index);
      }
    }
  };

  const handleChangeSelectedValue = () => {
    insertAttributeFunction(selectedRowDate, selectedRowAttributeId);

    if (selectedRowDate.length === 0) {
      deleteTableRows(deleteRowIndex);
    }
  };

  // Pull Attribute-
  const handlePullAttribute = (index, Attributeid, ID) => {
    setPull(!pull);
    const allAttribute = data?.newGlobalAttribute
      ?.filter((d) => d.Attributeid === Attributeid)
      ?.map((el) => {
        return {
          label: el.Name,
          value: el.ID,
          attributeId: el.Attributeid,
        };
      });
    insertAttributeFunction(allAttribute, Attributeid);
  };

  // Show Selected Attribute function-
  const showSelectedAttributeFunction = (Attributeid) => {
    return data?.newAttributeValue
      ?.filter((d) => d.Attributeid === Attributeid)
      ?.map((el) => {
        return {
          label: el.Name,
          value: el.Attributevalueid,
          attributeId: el.Attributeid,
        };
      });
  };

  // Show Selected All Options  function-
  const showAllSelectedOptionsFunction = (Attributeid, ID) => {
    return data?.newGlobalAttribute
      ?.filter((d) => d.Attributeid === Attributeid)
      ?.map((el) => {
        return {
          label: el.Name,
          value: el.ID,
          attributeId: el.Attributeid,
        };
      })
      ?.filter(
        (option) =>
          !data?.newAttributeValue
            ?.filter((d) => d.Attributeid === ID)
            ?.map((el) => {
              return {
                label: el.Name,
                value: el.ID,
                attributeId: el.Attributeid,
              };
            })
            .some((item) => item.label == option.label)
      );
  };

  // Disable pull button on the basis of attribute id-
  const disablePullButtonFunction = (Attributeid) => {
    return (
      data?.newAttributeValue?.filter((d) => d.Attributeid === Attributeid)
        .length ===
      data?.newGlobalAttribute?.filter((d) => d.Attributeid === Attributeid)
        .length
    );
  };

  return (
    <>
      {data?.newAttributeName?.map((el, index) => (
        <>
          <Loader loading={loading} />
          <tr key={index}>
            <td>{el.Name}</td>
            <td>
              <Select
                ref={selectRef}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isMulti={true}
                isClearable={false}
                placeholder=""
                // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                onChange={(value) =>
                  handleChangeAttributeValue(
                    value,
                    el.Attributeid,
                    index,
                    el.ID,
                    showSelectedAttributeFunction(el.Attributeid)?.length
                  )
                }
                id="Attributes"
                name="Attributes"
                value={showSelectedAttributeFunction(el.Attributeid)}
                options={showAllSelectedOptionsFunction(el.Attributeid, el.ID)}
              />
            </td>
            <td>
              <i
                className="fa fa-trash text-red fa-2x cursor-pointer"
                data-bs-toggle="tooltip"
                title="Delete"
                // onClick={() => deleteTableRows(index)}
                onClick={() => {
                  setDeleteRowIndex(index); // Set the index of the row to be deleted
                  setShowAttributePopup(true); // Show the popup
                  setModeltype("DeleteRow");
                }}
              />
            </td>
            <td>
              <input
                type="button"
                className={"btn btn-primary"}
                onClick={() =>
                  handlePullAttribute(index, el.Attributeid, el.ID)
                }
                value={"Pull"}
                disabled={disablePullButtonFunction(el.Attributeid)}
              />
            </td>
          </tr>
        </>
      ))}

      <Modal
        show={showAttributePopup}
        onHide={() => {
          setShowAttributePopup(false);
          setModeltype("");
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove this attribute? It will affect your
          variation.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setDeleteRowIndex(null); // Reset the index
              setShowAttributePopup(false); // Close the modal without deleting
              setModeltype("");
              setSelectedRowDate(null);
              setSelectedRowAttributeId(null);
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              if (deleteRowIndex !== null && modeltype === "DeleteRow") {
                deleteTableRows(deleteRowIndex); // Call delete function
                setDeleteRowIndex(null); // Reset the index
              }
              if (modeltype === "Attributevalue") {
                handleChangeSelectedValue();
                setSelectedRowDate(null);
                setSelectedRowAttributeId(null);
                setDeleteRowIndex(null);
              }
              setShowAttributePopup(false); // Close the modal
            }}
          >
            Confirm Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Modal
  show={showAttributePopup}
  onHide={() => setShowAttributePopup(false)}
  className="modal-md"
  id="ManageDataModal"
>
  <Modal.Header>
    <Modal.Title>Warning message</Modal.Title>
    <button
      type="button"
      className="btn-close"
      aria-label="Close"
      onClick={() => setShowAttributePopup(false)}
    >
      x
    </button>
  </Modal.Header>
  <Modal.Body>
    <p>Are you sure you want to remove this attribute? It will affect your variation.</p>
  </Modal.Body>
  <Modal.Footer>
    <button
      className="btn btn-sm btn-primary btn-md me-2"
      onClick={() => {
        if (deleteRowIndex !== null) {
          deleteTableRows(deleteRowIndex); // Call delete function
          setDeleteRowIndex(null); // Reset the index
        }
        setShowAttributePopup(false); // Close the modal
      }}
    >
      Confirm
    </button>
    <button
      className="btn btn-sm btn-dark btn-md me-1"
      onClick={() => {
        setDeleteRowIndex(null); // Reset the index
        setShowAttributePopup(false); // Close the modal without deleting
      }}
    >
      Cancel
    </button>
  </Modal.Footer>
</Modal> */}

      {/* Attribute Modal */}
      {/* <Modal
        show={showAttributePopup}
        onHide={() => setShowAttributePopup(false)}
        className="modal-md"
        id="ManageDataModal"
      >
        <Modal.Header>
          <Modal.Title>Warning message</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setShowAttributePopup(false);
            }}
          >
            x
          </button>
        </Modal.Header>
        <p>
          Are you sure?, you want to remove Attribute. it will affact your
          variation
        </p>

        <div className="col-lg-12 justify-content-right">
          <button
            // onClick={() =>} add function condition waise which is passed now
            className="btn btn-sm btn-primary btn-md me-2"
          >
            Confirm
          </button>

          <button
            className="btn btn-sm btn-dark btn-md me-1"
            onClick={setShowAttributePopup(false)}
          >
            Close
          </button>
        </div>
      </Modal> */}
    </>
  );
};

// const selectStyles = {
//   control: (provided) => ({
//     ...provided,
//     width: "100%",
//     height: "auto",
//     position: "relative",
//   }), // dropdown input css
//   menu: () => ({
//     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
//     position: "absolute",
//     background: "#f8f8f8",
//     width: "100%",
//     zIndex: 99,
//     // border: "solid orange",
//   }),
//   valueContainer: () => ({
//     // padding: "0px 6px !importan",
//     height: "auto !important",
//     display: "contents",
//   }),
// };

export default ItemAttributeTableRows;
